<template>
    <Popover class="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between px-4 py-6 sm:px-6 md:justify-start md:space-x-10">
            <div>
                <Link href="/" class="flex">
                    <img class="h-10 w-auto sm:h-10" src="/img/web3register-logo.png" alt="" />
                    <span class="text-white pt-2 ml-3">Web 3.0 Register</span>
                </Link>
            </div>
            <div class="-my-2 -mr-2 md:hidden">
                <PopoverButton class="inline-flex items-center justify-center p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span class="sr-only">{{t('menu.open')}}</span>
                    <Bars3Icon class="h-6 w-6" aria-hidden="true" />
                </PopoverButton>
            </div>
            <div class="hidden md:flex md:flex-1 md:items-center md:justify-between">
                <PopoverGroup as="nav" class="flex space-x-10">
                    <Popover class="relative" v-slot="{ open }">
                        <PopoverButton :class="[open ? 'text-white' : 'text-white', 'group inline-flex items-center text-white font-medium hover:text-white focus:outline-none']">
                            <span>{{ t('menu.types') }}</span>
                            <ChevronDownIcon :class="[open ? 'text-white' : 'text-white', 'ml-2 h-5 w-5 group-hover:text-gray-500']" aria-hidden="true" />
                        </PopoverButton>

                        <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
                            <PopoverPanel class="absolute z-10 -ml-4 mt-3 w-screen max-w-md transform lg:max-w-3xl">
                                <div class="overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                                    <div class="relative grid gap-6 px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                                        <a v-for="item in headerMenuTypes" :key="item.name" :href="item.href" class="-m-3 flex items-start rounded-lg p-3 hover:bg-gray-200">
                                            <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center bg-indigo-500 text-white sm:h-12 sm:w-12">
                                                <span v-html="item.icon"></span>
                                            </div>
                                            <div class="ml-4">
                                                <p class="text-black font-medium">{{ item.name }}</p>
                                                <p class="mt-1 text-sm text-gray-500">{{ item.description }}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </PopoverPanel>
                        </transition>
                    </Popover>
                    <Link v-if="user !== null" :href="route('dashboard_display_localized')" class="text-white font-medium">{{ t('menu.dashboard') }}</Link>
                </PopoverGroup>
                <div class="flex items-center md:ml-12">
                    <div class="hidden sm:ml-6 sm:flex sm:items-center" v-if="user !== null">
                        <Menu as="div" class="relative ml-3">
                            <div>
                                <MenuButton class="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 p-2">
                                    <span class="sr-only">Open user menu</span>
                                    <img class="h-8 w-8 rounded-full" :src="user.avatar" alt="" v-if="user.avatar" />
                                    <UserIcon class="h-6 w-6" aria-hidden="true" v-if="!user.avatar" />
                                </MenuButton>
                            </div>
                            <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    <MenuItem v-slot="{ active }">
                                        <Link :href="route('dashboard_display_localized')" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">{{ t('menu.dashboard') }}</Link>
                                    </MenuItem>
                                    <MenuItem v-slot="{ active }">
                                        <Link :href="route('profile_display_localized')" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">{{ t('menu.profile') }}</Link>
                                    </MenuItem>
                                    <MenuItem v-slot="{ active }">
                                        <a @click.prevent="logout()" href="#" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">{{ t('menu.logout') }}</a>
                                    </MenuItem>
                                </MenuItems>
                            </transition>
                        </Menu>
                    </div>
                    <Link v-if="user === null" :href="route('auth_login_display_localized')" class="text-white font-medium">{{ t('menu.signIn') }}</Link>
                    <Link v-if="user === null"  :href="route('auth_register_display_localized')" class="ml-8 inline-flex items-center justify-center border border-transparent bg-indigo-600 px-4 py-2 text-white font-medium shadow-sm hover:bg-indigo-700">{{ t('menu.signUp') }}</Link>
                </div>
            </div>
        </div>

        <transition enter-active-class="duration-200 ease-out" enter-from-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100" leave-active-class="duration-100 ease-in" leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
            <PopoverPanel focus class="absolute inset-x-0 top-0 origin-top-right transform p-2 transition md:hidden">
                <div class="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    <div class="px-5 pt-5 pb-6">
                        <div class="flex items-center justify-between">
                            <div>
                                <img class="h-8 w-auto" src="/img/web3register-logo.png" alt="Web3register" />
                            </div>
                            <div class="-mr-2">
                                <PopoverButton class="inline-flex items-center justify-center bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                    <span class="sr-only">{{t('menu.close')}}</span>
                                    <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                                </PopoverButton>
                            </div>
                        </div>
                        <div class="mt-6">
                            <nav class="grid gap-6">
                                <PopoverButton as="a" v-for="item in headerMenuTypes" :key="item.name" :href="item.href" class="-m-3 flex items-center rounded-lg p-3 hover:bg-gray-50">
                                    <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center bg-indigo-500 text-white">
                                        <span v-html="item.icon"></span>
                                    </div>
                                    <div class="ml-4 text-base font-medium text-gray-900">{{ item.name }}</div>
                                </PopoverButton>
                            </nav>
                        </div>
                    </div>
                    <div class="py-6 px-5">
                        <div class="mt-6">
                            <PopoverButton as="a" v-if="user !== null" :href="route('dashboard_display_localized')" class="flex w-full items-center justify-center border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700">{{  t('menu.dashboard') }}</PopoverButton>
                            <PopoverButton as="a" v-if="user !== null" :href="route('profile_display_localized')" class="flex w-full items-center justify-center border border-transparent px-4 py-2 text-base font-medium text-black">{{  t('menu.profile') }}</PopoverButton>
                            <PopoverButton as="a" v-if="user === null" :href="route('auth_register_display_localized')" class="flex w-full items-center justify-center border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700">{{  t('menu.signUp') }}</PopoverButton>
                            <p v-if="user === null" class="mt-6 text-center text-base font-medium text-gray-500">
                                {{t('menu.existing')}}
                                {{ ' ' }}
                                <PopoverButton as="a" :href="route('auth_login_display_localized')" class="text-indigo-600 hover:text-indigo-500">{{  t('menu.signIn') }}</PopoverButton>
                            </p>
                            <PopoverButton as="a" v-if="user !== null" @click.prevent="logout()"  href="#" class="flex w-full items-center justify-center border border-transparent px-4 py-2 text-base font-medium text-black">{{  t('menu.logout') }}</PopoverButton>
                        </div>
                    </div>
                </div>
            </PopoverPanel>
        </transition>
    </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverGroup, PopoverPanel, MenuButton, MenuItem, MenuItems, Menu } from '@headlessui/vue'
import {
    ArrowPathIcon,
    BellIcon,
    Bars3Icon,
    ChartBarIcon,
    CursorArrowRaysIcon,
    DocumentChartBarIcon,
    ShieldCheckIcon,
    Squares2X2Icon,
    XMarkIcon,
    UserIcon
} from '@heroicons/vue/24/outline'
import translate from "../../lang";
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import {Link, usePage} from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import {Inertia} from "@inertiajs/inertia";

let user = computed(() => usePage().props.value.auth.user);

const active = false;
const userNavigation = [
    { name: 'Your Profile', href: '#' },
    { name: 'Settings', href: '#' },
    { name: 'Sign out', href: '#' },
]
const headerMenuTypes = computed(() => usePage().props.value.headerMenuTypes);

function logout() {
    axios.post(route('auth_logout_localized')).then(function() {
        Inertia.visit(route('home_localized'));
    });
}

let t = translate('global');

</script>
